<template>
  <ul class="juicer-feed" :data-feed-id="feedId"></ul>
</template>

<script>
export default {
  name: 'InstagramWall',
  props: {
    feedId: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.loadStylesheet();
    this.loadScript();
  },
  methods: {
    loadStylesheet() {
      var link = document.createElement('link');
      link.href = 'https://assets.juicer.io/embed.css';
      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.media = 'all';

      document.head.appendChild(link);
    },
    loadScript() {
      var script = document.createElement('script');
      script.src = 'https://assets.juicer.io/embed.js';

      document.head.appendChild(script); //or something of the likes
    },
  },
};
</script>
